function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.18,6a15,15,0,1,0,15,15A15,15,0,0,0,22.18,6Zm0,28a13,13,0,1,1,13-13A13,13,0,0,1,22.18,34Zm-1-10h2V14h-2Zm0,4h2V26h-2Z",
  transform: "translate(-7.18 -6.03)"
});

var SvgLogsStopped = function SvgLogsStopped(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("span", {
    className: "svg_icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f98f2f",
    fillRule: "evenodd",
    width: "20px",
    height: "20px",
    "data-name": "Logs Backup stopped Icon",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogsStopped, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs_stopped.e8fce3c4.svg";
export { ForwardRef as ReactComponent };